// Phases listing events (analytics sheet → "Phases Listing Page"). The phase
// *details* events now come from the shared `detailAnalytics` factory.
import {AnalyticsEntryPoint} from './events';
import {listingAnalytics} from './listing-page.analytics';

const phases = listingAnalytics(AnalyticsEntryPoint.PhasesListingPage);

export const trackPhasesListingCardClick = phases.cardClick;
export const trackPhasesListingViewItemClick = phases.viewItemClick;
export const trackPhasesListingRegisterInterestClick = phases.registerInterestClick;
